//actions
import {
  //reservation
  FOOD_TABLE_RESERVATION_LIST,
  FOOD_TABLE_RESERVATION_LIST_SUCCESS,
  FOOD_TABLE_RESERVATION_LIST_FAIL,
  FOOD_TABLE_RESERVATION_LIST_TODAY,
  FOOD_TABLE_RESERVATION_LIST_TODAY_SUCCESS,
  FOOD_TABLE_RESERVATION_LIST_TODAY_FAIL,
  FOOD_TABLE_RESERVATION_LIST_TOMORROW,
  FOOD_TABLE_RESERVATION_LIST_TOMORROW_SUCCESS,
  FOOD_TABLE_RESERVATION_LIST_TOMORROW_FAIL,
  FOOD_TABLE_RESERVATION_LIST_FUTURE,
  FOOD_TABLE_RESERVATION_LIST_FUTURE_SUCCESS,
  FOOD_TABLE_RESERVATION_LIST_FUTURE_FAIL,
  FOOD_TABLE_RESERVATION_DATA,
  FOOD_TABLE_RESERVATION_DATA_SUCCESS,
  FOOD_TABLE_RESERVATION_DATA_FAIL,
  FOOD_TABLE_RESERVATION_CREATE,
  FOOD_TABLE_RESERVATION_CREATE_SUCCESS,
  FOOD_TABLE_RESERVATION_CREATE_FAIL,
  FOOD_TABLE_RESERVATION_IMPORT,
  FOOD_TABLE_RESERVATION_IMPORT_SUCCESS,
  FOOD_TABLE_RESERVATION_IMPORT_FAIL,
  FOOD_TABLE_RESERVATION_UPDATE,
  FOOD_TABLE_RESERVATION_UPDATE_SUCCESS,
  FOOD_TABLE_RESERVATION_UPDATE_FAIL,
  FOOD_TABLE_RESERVATION_DELETE,
  FOOD_TABLE_RESERVATION_DELETE_SUCCESS,
  FOOD_TABLE_RESERVATION_DELETE_FAIL,

  //Area
  FOOD_TABLE_AREA_LIST,
  FOOD_TABLE_AREA_LIST_SUCCESS,
  FOOD_TABLE_AREA_LIST_FAIL,
  FOOD_TABLE_AREA_DATA,
  FOOD_TABLE_AREA_DATA_SUCCESS,
  FOOD_TABLE_AREA_DATA_FAIL,
  FOOD_TABLE_AREA_CREATE,
  FOOD_TABLE_AREA_CREATE_SUCCESS,
  FOOD_TABLE_AREA_CREATE_FAIL,
  FOOD_TABLE_AREA_UPDATE,
  FOOD_TABLE_AREA_UPDATE_SUCCESS,
  FOOD_TABLE_AREA_UPDATE_FAIL,
  FOOD_TABLE_AREA_DELETE,
  FOOD_TABLE_AREA_DELETE_SUCCESS,
  FOOD_TABLE_AREA_DELETE_FAIL,

  //Table
  FOOD_TABLE_LIST,
  FOOD_TABLE_LIST_SUCCESS,
  FOOD_TABLE_LIST_FAIL,
  FOOD_TABLE_DATA,
  FOOD_TABLE_DATA_SUCCESS,
  FOOD_TABLE_DATA_FAIL,
  FOOD_TABLE_CREATE,
  FOOD_TABLE_CREATE_SUCCESS,
  FOOD_TABLE_CREATE_FAIL,
  FOOD_TABLE_UPDATE,
  FOOD_TABLE_UPDATE_SUCCESS,
  FOOD_TABLE_UPDATE_FAIL,
  FOOD_TABLE_DELETE,
  FOOD_TABLE_DELETE_SUCCESS,
  FOOD_TABLE_DELETE_FAIL,

  //FOOD_TABLE_RESERVATION_SEARCH
  FOOD_TABLE_RESERVATION_SEARCH,
  FOOD_TABLE_RESERVATION_SEARCH_SUCCESS,
  FOOD_TABLE_RESERVATION_SEARCH_FAIL,

  //FOOD_TABLE_BLOCK_LIST
  FOOD_TABLE_BLOCK_LIST,
  FOOD_TABLE_BLOCK_LIST_SUCCESS,
  FOOD_TABLE_BLOCK_LIST_FAIL,
  //FOOD_TABLE_BLOCK_DATA
  FOOD_TABLE_BLOCK_DATA,
  FOOD_TABLE_BLOCK_DATA_SUCCESS,
  FOOD_TABLE_BLOCK_DATA_FAIL,
  //FOOD_TABLE_BLOCK_CREATE
  FOOD_TABLE_BLOCK_CREATE,
  FOOD_TABLE_BLOCK_CREATE_SUCCESS,
  FOOD_TABLE_BLOCK_CREATE_FAIL,
  //FOOD_TABLE_DIARY_BLOCK_UPDATE
  FOOD_TABLE_DIARY_BLOCK_UPDATE,
  FOOD_TABLE_DIARY_BLOCK_UPDATE_SUCCESS,
  FOOD_TABLE_DIARY_BLOCK_UPDATE_FAIL,
  //FOOD_TABLE_BLOCK_DELETE
  FOOD_TABLE_BLOCK_DELETE,
  FOOD_TABLE_BLOCK_DELETE_SUCCESS,
  FOOD_TABLE_BLOCK_DELETE_FAIL,
  //FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UPDATE
  FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UPDATE,
  FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UPDATE_SUCCESS,
  FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UPDATE_FAIL,
  //FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_CANCEL
  FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_CANCEL,
  FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_CANCEL_SUCCESS,
  FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_CANCEL_FAIL,
  //FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UNASSIGN / _ASSIGN (Task 24607)
  FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UNASSIGN,
  FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UNASSIGN_SUCCESS,
  FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UNASSIGN_FAIL,
  FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_ASSIGN,
  FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_ASSIGN_SUCCESS,
  FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_ASSIGN_FAIL,
  //FOOD_TABLE_DIARY_RULE_LIST
  FOOD_TABLE_DIARY_RULE_LIST,
  FOOD_TABLE_DIARY_RULE_LIST_SUCCESS,
  FOOD_TABLE_DIARY_RULE_LIST_FAIL,
  //FOOD_TABLE_DIARY_RULE_DATA
  FOOD_TABLE_DIARY_RULE_DATA,
  FOOD_TABLE_DIARY_RULE_DATA_SUCCESS,
  FOOD_TABLE_DIARY_RULE_DATA_FAIL,
  //FOOD_TABLE_DIARY_RULE_CREATE
  FOOD_TABLE_DIARY_RULE_CREATE,
  FOOD_TABLE_DIARY_RULE_CREATE_SUCCESS,
  FOOD_TABLE_DIARY_RULE_CREATE_FAIL,
  //FOOD_TABLE_DIARY_RULE_UPDATE
  FOOD_TABLE_DIARY_RULE_UPDATE,
  FOOD_TABLE_DIARY_RULE_UPDATE_SUCCESS,
  FOOD_TABLE_DIARY_RULE_UPDATE_FAIL,
  //FOOD_TABLE_DIARY_RULE_DELETE
  FOOD_TABLE_DIARY_RULE_DELETE,
  FOOD_TABLE_DIARY_RULE_DELETE_SUCCESS,
  FOOD_TABLE_DIARY_RULE_DELETE_FAIL,
  //FOOD_TABLE_REORDER
  FOOD_TABLE_REORDER,
  FOOD_TABLE_REORDER_SUCCESS,
  FOOD_TABLE_REORDER_FAIL,
  //FOOD_TABLE_FLOORPLAN_SAVE
  FOOD_TABLE_FLOORPLAN_SAVE,
  FOOD_TABLE_FLOORPLAN_SAVE_SUCCESS,
  FOOD_TABLE_FLOORPLAN_SAVE_FAIL,
  //FOOD_TABLE_DIARY_RULE_REORDER
  FOOD_TABLE_DIARY_RULE_REORDER,
  FOOD_TABLE_DIARY_RULE_REORDER_SUCCESS,
  FOOD_TABLE_DIARY_RULE_REORDER_FAIL,
  //FOOD_TABLE_DIARY_RULE_SEARCH
  FOOD_TABLE_DIARY_RULE_SEARCH,
  FOOD_TABLE_DIARY_RULE_SEARCH_SUCCESS,
  FOOD_TABLE_DIARY_RULE_SEARCH_FAIL,
  //FOOD_TABLE_DIARY_RULE_SEARCH_BY_TIMESLOT
  FOOD_TABLE_DIARY_RULE_SEARCH_BY_TIMESLOT,
  FOOD_TABLE_DIARY_RULE_SEARCH_BY_TIMESLOT_SUCCESS,
  FOOD_TABLE_DIARY_RULE_SEARCH_BY_TIMESLOT_FAIL,
  //FOOD_TABLE_SEARCH
  FOOD_TABLE_SEARCH,
  FOOD_TABLE_SEARCH_SUCCESS,
  FOOD_TABLE_SEARCH_FAIL,
  FOOD_TABLE_AREA_SEARCH,
  FOOD_TABLE_AREA_SEARCH_SUCCESS,
  FOOD_TABLE_AREA_SEARCH_FAIL,
  //Booking Duration Rule
  FOOD_TABLE_DURATION_RULE_SEARCH,
  FOOD_TABLE_DURATION_RULE_SEARCH_SUCCESS,
  FOOD_TABLE_DURATION_RULE_SEARCH_FAIL,
  FOOD_TABLE_DURATION_RULE_DATA,
  FOOD_TABLE_DURATION_RULE_DATA_SUCCESS,
  FOOD_TABLE_DURATION_RULE_DATA_FAIL,
  FOOD_TABLE_DURATION_RULE_CREATE,
  FOOD_TABLE_DURATION_RULE_CREATE_SUCCESS,
  FOOD_TABLE_DURATION_RULE_CREATE_FAIL,
  FOOD_TABLE_DURATION_RULE_UPDATE,
  FOOD_TABLE_DURATION_RULE_UPDATE_SUCCESS,
  FOOD_TABLE_DURATION_RULE_UPDATE_FAIL,
  FOOD_TABLE_DURATION_RULE_DELETE,
  FOOD_TABLE_DURATION_RULE_DELETE_SUCCESS,
  FOOD_TABLE_DURATION_RULE_DELETE_FAIL,
  FOOD_TABLE_RULE_SEARCH,
  FOOD_TABLE_RULE_SEARCH_SUCCESS,
  FOOD_TABLE_RULE_SEARCH_FAIL,
  //FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_PDF_RUNNING_ORDER
  FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_PDF_RUNNING_ORDER,
  FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_PDF_RUNNING_ORDER_SUCCESS,
  FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_PDF_RUNNING_ORDER_FAIL,
  //FOOD_TABLE_RESERVATION_CHECK_AVAILABILITY
  FOOD_TABLE_RESERVATION_CHECK_AVAILABILITY,
  FOOD_TABLE_RESERVATION_CHECK_AVAILABILITY_SUCCESS,
  FOOD_TABLE_RESERVATION_CHECK_AVAILABILITY_FAIL,
  //FOOD_TABLE_RESERVATION_SEARCH_SINGLE_CUSTOMER
  FOOD_TABLE_RESERVATION_SEARCH_SINGLE_CUSTOMER,
  FOOD_TABLE_RESERVATION_SEARCH_SINGLE_CUSTOMER_SUCCESS,
  FOOD_TABLE_RESERVATION_SEARCH_SINGLE_CUSTOMER_FAIL,
  // Join Tables
  //FOOD_TABLE_JOIN_LIST
  FOOD_TABLE_JOIN_LIST,
  FOOD_TABLE_JOIN_LIST_SUCCESS,
  FOOD_TABLE_JOIN_LIST_FAIL,
  //FOOD_TABLE_JOIN_DATA
  FOOD_TABLE_JOIN_DATA,
  FOOD_TABLE_JOIN_DATA_SUCCESS,
  FOOD_TABLE_JOIN_DATA_FAIL,
  //FOOD_TABLE_JOIN_CREATE
  FOOD_TABLE_JOIN_CREATE,
  FOOD_TABLE_JOIN_CREATE_SUCCESS,
  FOOD_TABLE_JOIN_CREATE_FAIL,
  //FOOD_TABLE_JOIN_DELETE
  FOOD_TABLE_JOIN_DELETE,
  FOOD_TABLE_JOIN_DELETE_SUCCESS,
  FOOD_TABLE_JOIN_DELETE_FAIL,
  //FOOD_TABLE_JOIN_SEARCH
  FOOD_TABLE_JOIN_SEARCH,
  FOOD_TABLE_JOIN_SEARCH_SUCCESS,
  FOOD_TABLE_JOIN_SEARCH_FAIL,
  //FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_LIST
  FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_LIST,
  FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_LIST_SUCCESS,
  FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_LIST_FAIL,
  FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_DATA,
  FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_DATA_SUCCESS,
  FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_DATA_FAIL,
  FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_CREATE,
  FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_CREATE_SUCCESS,
  FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_CREATE_FAIL,
  FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_UPDATE,
  FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_UPDATE_SUCCESS,
  FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_UPDATE_FAIL,
  FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_DELETE,
  FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_DELETE_SUCCESS,
  FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_DELETE_FAIL,
} from "./actionType";

//FOOD_TABLE_RESERVATION_LIST
export const foodTableReservationList = (data) => ({
  type: FOOD_TABLE_RESERVATION_LIST,
  data,
});

export const foodTableReservationListSuccess = (data) => ({
  type: FOOD_TABLE_RESERVATION_LIST_SUCCESS,
  data,
});

export const foodTableReservationListFail = (data) => ({
  type: FOOD_TABLE_RESERVATION_LIST_FAIL,
  data,
});

//FOOD_TABLE_RESERVATION_LIST_TODAY
export const foodTableReservationListToday = (data) => ({
  type: FOOD_TABLE_RESERVATION_LIST_TODAY,
  data,
});

export const foodTableReservationListTodaySuccess = (data) => ({
  type: FOOD_TABLE_RESERVATION_LIST_TODAY_SUCCESS,
  data,
});

export const foodTableReservationListTodayFail = (data) => ({
  type: FOOD_TABLE_RESERVATION_LIST_TODAY_FAIL,
  data,
});

//FOOD_TABLE_RESERVATION_LIST_TOMORROW
export const foodTableReservationListTomorrow = (data) => ({
  type: FOOD_TABLE_RESERVATION_LIST_TOMORROW,
  data,
});

export const foodTableReservationListTomorrowSuccess = (data) => ({
  type: FOOD_TABLE_RESERVATION_LIST_TOMORROW_SUCCESS,
  data,
});

export const foodTableReservationListTomorrowFail = (data) => ({
  type: FOOD_TABLE_RESERVATION_LIST_TOMORROW_FAIL,
  data,
});

//FOOD_TABLE_RESERVATION_LIST_FUTURE
export const foodTableReservationListFuture = (data) => ({
  type: FOOD_TABLE_RESERVATION_LIST_FUTURE,
  data,
});

export const foodTableReservationListFutureSuccess = (data) => ({
  type: FOOD_TABLE_RESERVATION_LIST_FUTURE_SUCCESS,
  data,
});

export const foodTableReservationListFutureFail = (data) => ({
  type: FOOD_TABLE_RESERVATION_LIST_FUTURE_FAIL,
  data,
});

//FOOD_TABLE_RESERVATION_DATA
export const foodTableReservationData = (data) => ({
  type: FOOD_TABLE_RESERVATION_DATA,
  data,
});

export const foodTableReservationDataSuccess = (data) => ({
  type: FOOD_TABLE_RESERVATION_DATA_SUCCESS,
  data,
});

export const foodTableReservationDataFail = (data) => ({
  type: FOOD_TABLE_RESERVATION_DATA_FAIL,
  data,
});

//FOOD_TABLE_RESERVATION_CREATE
export const foodTableReservationCreate = (data) => ({
  type: FOOD_TABLE_RESERVATION_CREATE,
  data,
});

export const foodTableReservationCreateSuccess = (data) => ({
  type: FOOD_TABLE_RESERVATION_CREATE_SUCCESS,
  data,
});

export const foodTableReservationCreateFail = (data) => ({
  type: FOOD_TABLE_RESERVATION_CREATE_FAIL,
  data,
});

//FOOD_TABLE_RESERVATION_IMPORT
export const foodTableReservationImport = (data) => ({
  type: FOOD_TABLE_RESERVATION_IMPORT,
  data,
});

export const foodTableReservationImportSuccess = (data) => ({
  type: FOOD_TABLE_RESERVATION_IMPORT_SUCCESS,
  data,
});

export const foodTableReservationImportFail = (data) => ({
  type: FOOD_TABLE_RESERVATION_IMPORT_FAIL,
  data,
});

//FOOD_TABLE_RESERVATION_UPDATE
export const foodTableReservationUpdate = (data) => ({
  type: FOOD_TABLE_RESERVATION_UPDATE,
  data,
});

export const foodTableReservationUpdateSuccess = (data) => ({
  type: FOOD_TABLE_RESERVATION_UPDATE_SUCCESS,
  data,
});

export const foodTableReservationUpdateFail = (data) => ({
  type: FOOD_TABLE_RESERVATION_UPDATE_FAIL,
  data,
});

//FOOD_TABLE_RESERVATION_DELETE
export const foodTableReservationDelete = (data) => ({
  type: FOOD_TABLE_RESERVATION_DELETE,
  data,
});

export const foodTableReservationDeleteSuccess = (data) => ({
  type: FOOD_TABLE_RESERVATION_DELETE_SUCCESS,
  data,
});

export const foodTableReservationDeleteFail = (data) => ({
  type: FOOD_TABLE_RESERVATION_DELETE_FAIL,
  data,
});

//FOOD_TABLE_AREA_LIST
export const foodTableAreaList = (data) => ({
  type: FOOD_TABLE_AREA_LIST,
  data,
});

export const foodTableAreaListSuccess = (data) => ({
  type: FOOD_TABLE_AREA_LIST_SUCCESS,
  data,
});

export const foodTableAreaListFail = (data) => ({
  type: FOOD_TABLE_AREA_LIST_FAIL,
  data,
});

//FOOD_TABLE_AREA_DATA
export const foodTableAreaData = (data) => ({
  type: FOOD_TABLE_AREA_DATA,
  data,
});

export const foodTableAreaDataSuccess = (data) => ({
  type: FOOD_TABLE_AREA_DATA_SUCCESS,
  data,
});

export const foodTableAreaDataFail = (data) => ({
  type: FOOD_TABLE_AREA_DATA_FAIL,
  data,
});

//FOOD_TABLE_AREA_CREATE
export const foodTableAreaCreate = (data) => ({
  type: FOOD_TABLE_AREA_CREATE,
  data,
});

export const foodTableAreaCreateSuccess = (data) => ({
  type: FOOD_TABLE_AREA_CREATE_SUCCESS,
  data,
});

export const foodTableAreaCreateFail = (data) => ({
  type: FOOD_TABLE_AREA_CREATE_FAIL,
  data,
});

//FOOD_TABLE_AREA_UPDATE
export const foodTableAreaUpdate = (data) => ({
  type: FOOD_TABLE_AREA_UPDATE,
  data,
});

export const foodTableAreaUpdateSuccess = (data) => ({
  type: FOOD_TABLE_AREA_UPDATE_SUCCESS,
  data,
});

export const foodTableAreaUpdateFail = (data) => ({
  type: FOOD_TABLE_AREA_UPDATE_FAIL,
  data,
});

//FOOD_TABLE_AREA_DELETE
export const foodTableAreaDelete = (data) => ({
  type: FOOD_TABLE_AREA_DELETE,
  data,
});

export const foodTableAreaDeleteSuccess = (data) => ({
  type: FOOD_TABLE_AREA_DELETE_SUCCESS,
  data,
});

export const foodTableAreaDeleteFail = (data) => ({
  type: FOOD_TABLE_AREA_DELETE_FAIL,
  data,
});

//FOOD_TABLE_LIST
export const foodTableList = (data) => ({
  type: FOOD_TABLE_LIST,
  data,
});

export const foodTableListSuccess = (data) => ({
  type: FOOD_TABLE_LIST_SUCCESS,
  data,
});

export const foodTableListFail = (data) => ({
  type: FOOD_TABLE_LIST_FAIL,
  data,
});

//FOOD_TABLE_DATA
export const foodTableData = (data) => ({
  type: FOOD_TABLE_DATA,
  data,
});

export const foodTableDataSuccess = (data) => ({
  type: FOOD_TABLE_DATA_SUCCESS,
  data,
});

export const foodTableDataFail = (data) => ({
  type: FOOD_TABLE_DATA_FAIL,
  data,
});

//FOOD_TABLE_CREATE
export const foodTableCreate = (data) => ({
  type: FOOD_TABLE_CREATE,
  data,
});

export const foodTableCreateSuccess = (data) => ({
  type: FOOD_TABLE_CREATE_SUCCESS,
  data,
});

export const foodTableCreateFail = (data) => ({
  type: FOOD_TABLE_CREATE_FAIL,
  data,
});

//FOOD_TABLE_UPDATE
export const foodTableUpdate = (data) => ({
  type: FOOD_TABLE_UPDATE,
  data,
});

export const foodTableUpdateSuccess = (data) => ({
  type: FOOD_TABLE_UPDATE_SUCCESS,
  data,
});

export const foodTableUpdateFail = (data) => ({
  type: FOOD_TABLE_UPDATE_FAIL,
  data,
});

//FOOD_TABLE_DELETE
export const foodTableDelete = (data) => ({
  type: FOOD_TABLE_DELETE,
  data,
});

export const foodTableDeleteSuccess = (data) => ({
  type: FOOD_TABLE_DELETE_SUCCESS,
  data,
});

export const foodTableDeleteFail = (data) => ({
  type: FOOD_TABLE_DELETE_FAIL,
  data,
});

//FOOD_TABLE_RESERVATION_SEARCH
export const foodTableReservationSearch = (data) => ({
  type: FOOD_TABLE_RESERVATION_SEARCH,
  data,
});

export const foodTableReservationSearchSuccess = (data) => ({
  type: FOOD_TABLE_RESERVATION_SEARCH_SUCCESS,
  data,
});

export const foodTableReservationSearchFail = (data) => ({
  type: FOOD_TABLE_RESERVATION_SEARCH_FAIL,
  data,
});

//FOOD_TABLE_BLOCK_LIST
export const foodTableBlockList = (data) => ({
  type: FOOD_TABLE_BLOCK_LIST,
  data,
});

export const foodTableBlockListSuccess = (data) => ({
  type: FOOD_TABLE_BLOCK_LIST_SUCCESS,
  data,
});

export const foodTableBlockListFail = (data) => ({
  type: FOOD_TABLE_BLOCK_LIST_FAIL,
  data,
});

//FOOD_TABLE_BLOCK_DATA
export const foodTableBlockData = (data) => ({
  type: FOOD_TABLE_BLOCK_DATA,
  data,
});

export const foodTableBlockDataSuccess = (data) => ({
  type: FOOD_TABLE_BLOCK_DATA_SUCCESS,
  data,
});

export const foodTableBlockDataFail = (data) => ({
  type: FOOD_TABLE_BLOCK_DATA_FAIL,
  data,
});

//FOOD_TABLE_BLOCK_CREATE
export const foodTableBlockCreate = (data) => ({
  type: FOOD_TABLE_BLOCK_CREATE,
  data,
});

export const foodTableBlockCreateSuccess = (data) => ({
  type: FOOD_TABLE_BLOCK_CREATE_SUCCESS,
  data,
});

export const foodTableBlockCreateFail = (data) => ({
  type: FOOD_TABLE_BLOCK_CREATE_FAIL,
  data,
});

//FOOD_TABLE_DIARY_BLOCK_UPDATE
export const foodTableDiaryBlockUpdate = (data) => ({
  type: FOOD_TABLE_DIARY_BLOCK_UPDATE,
  data,
});

export const foodTableDiaryBlockUpdateSuccess = (data) => ({
  type: FOOD_TABLE_DIARY_BLOCK_UPDATE_SUCCESS,
  data,
});

export const foodTableDiaryBlockUpdateFail = (data) => ({
  type: FOOD_TABLE_DIARY_BLOCK_UPDATE_FAIL,
  data,
});

//FOOD_TABLE_BLOCK_DELETE
export const foodTableBlockDelete = (data) => ({
  type: FOOD_TABLE_BLOCK_DELETE,
  data,
});

export const foodTableBlockDeleteSuccess = (data) => ({
  type: FOOD_TABLE_BLOCK_DELETE_SUCCESS,
  data,
});

export const foodTableBlockDeleteFail = (data) => ({
  type: FOOD_TABLE_BLOCK_DELETE_FAIL,
  data,
});

//FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UPDATE
export const foodTableReservationTableAssignmentUpdate = (data) => ({
  type: FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UPDATE,
  data,
});

export const foodTableReservationTableAssignmentUpdateSuccess = (data) => ({
  type: FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UPDATE_SUCCESS,
  data,
});

export const foodTableReservationTableAssignmentUpdateFail = (data) => ({
  type: FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UPDATE_FAIL,
  data,
});

//FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_CANCEL
export const foodTableReservationTableAssignmentCancel = (data) => ({
  type: FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_CANCEL,
  data,
});

export const foodTableReservationTableAssignmentCancelSuccess = (data) => ({
  type: FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_CANCEL_SUCCESS,
  data,
});

export const foodTableReservationTableAssignmentCancelFail = (data) => ({
  type: FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_CANCEL_FAIL,
  data,
});

//FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UNASSIGN (Task 24607)
export const foodTableReservationTableAssignmentUnassign = (data) => ({
  type: FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UNASSIGN,
  data,
});

export const foodTableReservationTableAssignmentUnassignSuccess = (data) => ({
  type: FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UNASSIGN_SUCCESS,
  data,
});

export const foodTableReservationTableAssignmentUnassignFail = (data) => ({
  type: FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UNASSIGN_FAIL,
  data,
});

//FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_ASSIGN (Task 24607)
export const foodTableReservationTableAssignmentAssign = (data) => ({
  type: FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_ASSIGN,
  data,
});

export const foodTableReservationTableAssignmentAssignSuccess = (data) => ({
  type: FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_ASSIGN_SUCCESS,
  data,
});

export const foodTableReservationTableAssignmentAssignFail = (data) => ({
  type: FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_ASSIGN_FAIL,
  data,
});

//FOOD_TABLE_DIARY_RULE_LIST
export const foodTableDiaryRuleList = (data) => ({
  type: FOOD_TABLE_DIARY_RULE_LIST,
  data,
});

export const foodTableDiaryRuleListSuccess = (data) => ({
  type: FOOD_TABLE_DIARY_RULE_LIST_SUCCESS,
  data,
});

export const foodTableDiaryRuleListFail = (data) => ({
  type: FOOD_TABLE_DIARY_RULE_LIST_FAIL,
  data,
});

//FOOD_TABLE_DIARY_RULE_DATA
export const foodTableDiaryRuleData = (data) => ({
  type: FOOD_TABLE_DIARY_RULE_DATA,
  data,
});

export const foodTableDiaryRuleDataSuccess = (data) => ({
  type: FOOD_TABLE_DIARY_RULE_DATA_SUCCESS,
  data,
});

export const foodTableDiaryRuleDataFail = (data) => ({
  type: FOOD_TABLE_DIARY_RULE_DATA_FAIL,
  data,
});

//FOOD_TABLE_DIARY_RULE_CREATE
export const foodTableDiaryRuleCreate = (data) => ({
  type: FOOD_TABLE_DIARY_RULE_CREATE,
  data,
});

export const foodTableDiaryRuleCreateSuccess = (data) => ({
  type: FOOD_TABLE_DIARY_RULE_CREATE_SUCCESS,
  data,
});

export const foodTableDiaryRuleCreateFail = (data) => ({
  type: FOOD_TABLE_DIARY_RULE_CREATE_FAIL,
  data,
});

//FOOD_TABLE_DIARY_RULE_UPDATE
export const foodTableDiaryRuleUpdate = (data) => ({
  type: FOOD_TABLE_DIARY_RULE_UPDATE,
  data,
});

export const foodTableDiaryRuleUpdateSuccess = (data) => ({
  type: FOOD_TABLE_DIARY_RULE_UPDATE_SUCCESS,
  data,
});

export const foodTableDiaryRuleUpdateFail = (data) => ({
  type: FOOD_TABLE_DIARY_RULE_UPDATE_FAIL,
  data,
});

//FOOD_TABLE_DIARY_RULE_DELETE
export const foodTableDiaryRuleDelete = (data) => ({
  type: FOOD_TABLE_DIARY_RULE_DELETE,
  data,
});

export const foodTableDiaryRuleDeleteSuccess = (data) => ({
  type: FOOD_TABLE_DIARY_RULE_DELETE_SUCCESS,
  data,
});

export const foodTableDiaryRuleDeleteFail = (data) => ({
  type: FOOD_TABLE_DIARY_RULE_DELETE_FAIL,
  data,
});

//FOOD_TABLE_REORDER (Task 24634)
export const foodTableReorder = (data) => ({
  type: FOOD_TABLE_REORDER,
  data,
});

export const foodTableReorderSuccess = (data) => ({
  type: FOOD_TABLE_REORDER_SUCCESS,
  data,
});

export const foodTableReorderFail = (data) => ({
  type: FOOD_TABLE_REORDER_FAIL,
  data,
});

//FOOD_TABLE_FLOORPLAN_SAVE (Task 24625)
export const foodTableFloorPlanSave = (data) => ({
  type: FOOD_TABLE_FLOORPLAN_SAVE,
  data,
});

export const foodTableFloorPlanSaveSuccess = (data) => ({
  type: FOOD_TABLE_FLOORPLAN_SAVE_SUCCESS,
  data,
});

export const foodTableFloorPlanSaveFail = (data) => ({
  type: FOOD_TABLE_FLOORPLAN_SAVE_FAIL,
  data,
});

//FOOD_TABLE_DIARY_RULE_REORDER
export const foodTableDiaryRuleReorder = (data) => ({
  type: FOOD_TABLE_DIARY_RULE_REORDER,
  data,
});

export const foodTableDiaryRuleReorderSuccess = (data) => ({
  type: FOOD_TABLE_DIARY_RULE_REORDER_SUCCESS,
  data,
});

export const foodTableDiaryRuleReorderFail = (data) => ({
  type: FOOD_TABLE_DIARY_RULE_REORDER_FAIL,
  data,
});

//FOOD_TABLE_DIARY_RULE_SEARCH
export const foodTableDiaryRuleSearch = (data) => ({
  type: FOOD_TABLE_DIARY_RULE_SEARCH,
  data,
});

export const foodTableDiaryRuleSearchSuccess = (data) => ({
  type: FOOD_TABLE_DIARY_RULE_SEARCH_SUCCESS,
  data,
});

export const foodTableDiaryRuleSearchFail = (data) => ({
  type: FOOD_TABLE_DIARY_RULE_SEARCH_FAIL,
  data,
});

//FOOD_TABLE_DIARY_RULE_SEARCH_BY_TIMESLOT
export const foodTableDiaryRuleSearchByTimeslot = (data) => ({
  type: FOOD_TABLE_DIARY_RULE_SEARCH_BY_TIMESLOT,
  data,
});

export const foodTableDiaryRuleSearchByTimeslotSuccess = (data) => ({
  type: FOOD_TABLE_DIARY_RULE_SEARCH_BY_TIMESLOT_SUCCESS,
  data,
});

export const foodTableDiaryRuleSearchByTimeslotFail = (data) => ({
  type: FOOD_TABLE_DIARY_RULE_SEARCH_BY_TIMESLOT_FAIL,
  data,
});

//FOOD_TABLE_SEARCH
export const foodTableSearch = (data) => ({
  type: FOOD_TABLE_SEARCH,
  data,
});

export const foodTableSearchSuccess = (data) => ({
  type: FOOD_TABLE_SEARCH_SUCCESS,
  data,
});

export const foodTableSearchFail = (data) => ({
  type: FOOD_TABLE_SEARCH_FAIL,
  data,
});

//FOOD_TABLE_AREA_SEARCH
export const foodTableAreaSearch = (data) => ({
  type: FOOD_TABLE_AREA_SEARCH,
  data,
});

export const foodTableAreaSearchSuccess = (data) => ({
  type: FOOD_TABLE_AREA_SEARCH_SUCCESS,
  data,
});

export const foodTableAreaSearchFail = (data) => ({
  type: FOOD_TABLE_AREA_SEARCH_FAIL,
  data,
});

//FOOD_TABLE_DURATION_RULE_SEARCH
export const foodTableDurationRuleSearch = (data) => ({
  type: FOOD_TABLE_DURATION_RULE_SEARCH,
  data,
});
export const foodTableDurationRuleSearchSuccess = (data) => ({
  type: FOOD_TABLE_DURATION_RULE_SEARCH_SUCCESS,
  data,
});
export const foodTableDurationRuleSearchFail = (data) => ({
  type: FOOD_TABLE_DURATION_RULE_SEARCH_FAIL,
  data,
});

//FOOD_TABLE_DURATION_RULE_DATA
export const foodTableDurationRuleData = (data) => ({
  type: FOOD_TABLE_DURATION_RULE_DATA,
  data,
});
export const foodTableDurationRuleDataSuccess = (data) => ({
  type: FOOD_TABLE_DURATION_RULE_DATA_SUCCESS,
  data,
});
export const foodTableDurationRuleDataFail = (data) => ({
  type: FOOD_TABLE_DURATION_RULE_DATA_FAIL,
  data,
});

//FOOD_TABLE_DURATION_RULE_CREATE
export const foodTableDurationRuleCreate = (data) => ({
  type: FOOD_TABLE_DURATION_RULE_CREATE,
  data,
});
export const foodTableDurationRuleCreateSuccess = (data) => ({
  type: FOOD_TABLE_DURATION_RULE_CREATE_SUCCESS,
  data,
});
export const foodTableDurationRuleCreateFail = (data) => ({
  type: FOOD_TABLE_DURATION_RULE_CREATE_FAIL,
  data,
});

//FOOD_TABLE_DURATION_RULE_UPDATE
export const foodTableDurationRuleUpdate = (data) => ({
  type: FOOD_TABLE_DURATION_RULE_UPDATE,
  data,
});
export const foodTableDurationRuleUpdateSuccess = (data) => ({
  type: FOOD_TABLE_DURATION_RULE_UPDATE_SUCCESS,
  data,
});
export const foodTableDurationRuleUpdateFail = (data) => ({
  type: FOOD_TABLE_DURATION_RULE_UPDATE_FAIL,
  data,
});

//FOOD_TABLE_DURATION_RULE_DELETE
export const foodTableDurationRuleDelete = (data) => ({
  type: FOOD_TABLE_DURATION_RULE_DELETE,
  data,
});
export const foodTableDurationRuleDeleteSuccess = (data) => ({
  type: FOOD_TABLE_DURATION_RULE_DELETE_SUCCESS,
  data,
});
export const foodTableDurationRuleDeleteFail = (data) => ({
  type: FOOD_TABLE_DURATION_RULE_DELETE_FAIL,
  data,
});

//FOOD_TABLE_RULE_SEARCH
export const foodTableRuleSearch = (data) => ({
  type: FOOD_TABLE_RULE_SEARCH,
  data,
});

export const foodTableRuleSearchSuccess = (data) => ({
  type: FOOD_TABLE_RULE_SEARCH_SUCCESS,
  data,
});

export const foodTableRuleSearchFail = (data) => ({
  type: FOOD_TABLE_RULE_SEARCH_FAIL,
  data,
});

//FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_PDF_RUNNING_ORDER
export const foodTableReservationTableAssignmentPdfRunningOrder = (data) => ({
  type: FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_PDF_RUNNING_ORDER,
  data,
});

export const foodTableReservationTableAssignmentPdfRunningOrderSuccess = (
  data
) => ({
  type: FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_PDF_RUNNING_ORDER_SUCCESS,
  data,
});

export const foodTableReservationTableAssignmentPdfRunningOrderFail = (
  data
) => ({
  type: FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_PDF_RUNNING_ORDER_FAIL,
  data,
});

//FOOD_TABLE_RESERVATION_CHECK_AVAILABILITY
export const foodTableReservationCheckAvailability = (data) => ({
  type: FOOD_TABLE_RESERVATION_CHECK_AVAILABILITY,
  data,
});

export const foodTableReservationCheckAvailabilitySuccess = (data) => ({
  type: FOOD_TABLE_RESERVATION_CHECK_AVAILABILITY_SUCCESS,
  data,
});

export const foodTableReservationCheckAvailabilityFail = (data) => ({
  type: FOOD_TABLE_RESERVATION_CHECK_AVAILABILITY_FAIL,
  data,
});

//FOOD_TABLE_RESERVATION_SEARCH_SINGLE_CUSTOMER
export const foodTableReservationSearchSingleCustomer = (data) => ({
  type: FOOD_TABLE_RESERVATION_SEARCH_SINGLE_CUSTOMER,
  data,
});
export const foodTableReservationSearchSingleCustomerSuccess = (data) => ({
  type: FOOD_TABLE_RESERVATION_SEARCH_SINGLE_CUSTOMER_SUCCESS,
  data,
});
export const foodTableReservationSearchSingleCustomerFail = (data) => ({
  type: FOOD_TABLE_RESERVATION_SEARCH_SINGLE_CUSTOMER_FAIL,
  data,
});
// Join Tables
//FOOD_TABLE_JOIN_LIST
export const foodTableJoinList = (data) => ({
  type: FOOD_TABLE_JOIN_LIST,
  data,
});

export const foodTableJoinListSuccess = (data) => ({
  type: FOOD_TABLE_JOIN_LIST_SUCCESS,
  data,
});

export const foodTableJoinListFail = (data) => ({
  type: FOOD_TABLE_JOIN_LIST_FAIL,
  data,
});

//FOOD_TABLE_JOIN_DATA
export const foodTableJoinData = (data) => ({
  type: FOOD_TABLE_JOIN_DATA,
  data,
});

export const foodTableJoinDataSuccess = (data) => ({
  type: FOOD_TABLE_JOIN_DATA_SUCCESS,
  data,
});

export const foodTableJoinDataFail = (data) => ({
  type: FOOD_TABLE_JOIN_DATA_FAIL,
  data,
});

//FOOD_TABLE_JOIN_CREATE
export const foodTableJoinCreate = (data) => ({
  type: FOOD_TABLE_JOIN_CREATE,
  data,
});

export const foodTableJoinCreateSuccess = (data) => ({
  type: FOOD_TABLE_JOIN_CREATE_SUCCESS,
  data,
});

export const foodTableJoinCreateFail = (data) => ({
  type: FOOD_TABLE_JOIN_CREATE_FAIL,
  data,
});

//FOOD_TABLE_JOIN_DELETE
export const foodTableJoinDelete = (data) => ({
  type: FOOD_TABLE_JOIN_DELETE,
  data,
});

export const foodTableJoinDeleteSuccess = (data) => ({
  type: FOOD_TABLE_JOIN_DELETE_SUCCESS,
  data,
});

export const foodTableJoinDeleteFail = (data) => ({
  type: FOOD_TABLE_JOIN_DELETE_FAIL,
  data,
});

//FOOD_TABLE_JOIN_SEARCH
export const foodTableJoinSearch = (data) => ({
  type: FOOD_TABLE_JOIN_SEARCH,
  data,
});

export const foodTableJoinSearchSuccess = (data) => ({
  type: FOOD_TABLE_JOIN_SEARCH_SUCCESS,
  data,
});

export const foodTableJoinSearchFail = (data) => ({
  type: FOOD_TABLE_JOIN_SEARCH_FAIL,
  data,
});

//FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_LIST
export const foodPreorderSiteLocationFloorPlanObjectList = () => ({
  type: FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_LIST,
});

export const foodPreorderSiteLocationFloorPlanObjectListSuccess = (data) => ({
  type: FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_LIST_SUCCESS,
  data,
});

export const foodPreorderSiteLocationFloorPlanObjectListFail = (data) => ({
  type: FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_LIST_FAIL,
  data,
});

//FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_DATA
export const foodPreorderSiteLocationFloorPlanObjectData = (data) => ({
  type: FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_DATA,
  data,
});

export const foodPreorderSiteLocationFloorPlanObjectDataSuccess = (data) => ({
  type: FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_DATA_SUCCESS,
  data,
});

export const foodPreorderSiteLocationFloorPlanObjectDataFail = (data) => ({
  type: FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_DATA_FAIL,
  data,
});

//FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_CREATE
export const foodPreorderSiteLocationFloorPlanObjectCreate = (data) => ({
  type: FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_CREATE,
  data,
});

export const foodPreorderSiteLocationFloorPlanObjectCreateSuccess = (
  data
) => ({
  type: FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_CREATE_SUCCESS,
  data,
});

export const foodPreorderSiteLocationFloorPlanObjectCreateFail = (data) => ({
  type: FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_CREATE_FAIL,
  data,
});

//FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_UPDATE
export const foodPreorderSiteLocationFloorPlanObjectUpdate = (data) => ({
  type: FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_UPDATE,
  data,
});

export const foodPreorderSiteLocationFloorPlanObjectUpdateSuccess = (
  data
) => ({
  type: FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_UPDATE_SUCCESS,
  data,
});

export const foodPreorderSiteLocationFloorPlanObjectUpdateFail = (data) => ({
  type: FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_UPDATE_FAIL,
  data,
});

//FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_DELETE
export const foodPreorderSiteLocationFloorPlanObjectDelete = (data) => ({
  type: FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_DELETE,
  data,
});

export const foodPreorderSiteLocationFloorPlanObjectDeleteSuccess = (
  data
) => ({
  type: FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_DELETE_SUCCESS,
  data,
});

export const foodPreorderSiteLocationFloorPlanObjectDeleteFail = (data) => ({
  type: FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_DELETE_FAIL,
  data,
});